module.exports = __webpack_public_path__ + "img/CA220K.3a3b6a0a.png";